import { createContext, type ReactNode, useContext, useMemo } from "react";

const Context = createContext<{ accounts: MultiAccountAccountData[]; showUnconfirmedLinesFilter: boolean }>({
  accounts: [],
  showUnconfirmedLinesFilter: false,
});

interface MultiAccountSearchDataJson {
  accounts: MultiAccountAccountData[];
}

export interface MultiAccountAccountData {
  code: string;
  endCustomer: MultiAccountEndCustomerData[];
  name: string;
  shortCode: string;
}

export interface MultiAccountEndCustomerData {
  code: string;
  name: string;
  salesOrg: string;
}

export const useMultiAccountSearchData = () => useContext(Context);

interface Props {
  children?: ReactNode | undefined;
  accountsJson: string | undefined | null;
  showUnconfirmedLinesFilter?: boolean;
}
export function MultiAccountSearchDataProvider({ children, accountsJson, showUnconfirmedLinesFilter = false }: Props) {
  const accounts = useMemo(() => {
    const data: MultiAccountSearchDataJson = accountsJson ? JSON.parse(accountsJson) : { accounts: [] };
    data.accounts.sort(SORT_ACCOUNT);
    data.accounts.forEach((account) => account.endCustomer.sort(SORT_END_CUSTOMER));
    return data.accounts;
  }, [accountsJson]);

  return <Context.Provider value={{ accounts, showUnconfirmedLinesFilter }}>{children}</Context.Provider>;
}

const SORT_ACCOUNT = (a: MultiAccountAccountData, b: MultiAccountAccountData) => {
  let val = (a.name ?? "").localeCompare(b.name ?? 0);
  if (val === 0) {
    const aCode = +(a.shortCode ?? 0);
    const bCode = +(b.shortCode ?? 0);
    val = aCode - bCode;
  }
  return val;
};

const SORT_END_CUSTOMER = (a: MultiAccountEndCustomerData, b: MultiAccountEndCustomerData) => {
  let val = (a.name ?? "").localeCompare(b.name ?? 0);
  if (val === 0) {
    const aCode = +(a.code ?? 0);
    const bCode = +(b.code ?? 0);
    val = aCode - bCode;
  }
  return val;
};
